// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { InternalTeamMemberDTO } from '../models';
/**
 * InternalTeamMembersApi - axios parameter creator
 * @export
 */
export const InternalTeamMembersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch all internal team members
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options: any = {}): RequestArgs {
            const localVarPath = `/v2/internal-team-members`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalTeamMembersApi - functional programming interface
 * @export
 */
export const InternalTeamMembersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Fetch all internal team members
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalTeamMemberDTO> {
            const localVarAxiosArgs = InternalTeamMembersApiAxiosParamCreator(configuration).findAll(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * InternalTeamMembersApi - factory interface
 * @export
 */
export const InternalTeamMembersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Fetch all internal team members
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options?: any) {
            return InternalTeamMembersApiFp(configuration).findAll(options)(axios, basePath);
        },
    };
};

/**
 * InternalTeamMembersApi - interface
 * @export
 * @interface InternalTeamMembersApi
 */
export interface InternalTeamMembersApiInterface {
    /**
     * Fetch all internal team members
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalTeamMembersApiInterface
     */
    findAll(options?: any): AxiosPromise<InternalTeamMemberDTO>;

}

/**
 * InternalTeamMembersApi - object-oriented interface
 * @export
 * @class InternalTeamMembersApi
 * @extends {BaseAPI}
 */
export class InternalTeamMembersApi extends BaseAPI implements InternalTeamMembersApiInterface {
    /**
     * Fetch all internal team members
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalTeamMembersApi
     */
    public findAll(options?: any) {
        return InternalTeamMembersApiFp(this.configuration).findAll(options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for InternalTeamMembersApi
 * Import individual functions for optimal bundle size
 */
/**
 * Fetch all internal team members
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findAll(
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<InternalTeamMemberDTO> {
    const localVarAxiosArgs = InternalTeamMembersApiAxiosParamCreator(configuration).findAll(options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

